import { Mapper } from "../../../../base/utils/mapper";
import { ProcedureAtenttionModel } from "../../../../domain/models/consult/procedure-atenttion.model";
import { ProcedureAtenttionEntity } from "../entities/procedure-atenttion.entity";

export class ProcedureAtenttionImplementationRepositoryMapper extends Mapper<ProcedureAtenttionEntity, ProcedureAtenttionModel> {
    mapFrom(param: ProcedureAtenttionEntity): ProcedureAtenttionModel {
        return {
            data:param.data,
            isSuccess:param.isSuccess,
            message:param.message,
            errors:param.errors
        };
    }
    mapTo(param: ProcedureAtenttionModel): ProcedureAtenttionEntity {
        return {
            data:param.data,
            isSuccess:param.isSuccess,
            message:param.message,
            errors:param.errors
        }
    }
}